// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3HpD7","clinicsSelect":"TableHeading_clinicsSelect__2sDeG"};